import React, { useReducer, useState } from 'react';
import styled from 'styled-components';

import { TextField, Typography } from '@material-ui/core';

import { Auth } from 'aws-amplify';

import BtnPrimary from '../common/BtnPrimary';
import InputPassword from '../common/inputs/InputPassword';
import PasswordStrengthMeter from '../common/PasswordStrengthMeter';

const Root = styled.div`
	form > div:last-child {
		margin: 20px 0;
		text-align: right;
	}

	.form__error {
		margin: 20px 0 10px 0;
		padding: 20px;
		background-color: ${(props) => props.theme.palette.background.error};
		color: ${(props) => props.theme.palette.text.primary};
		font-size: 16px;
		border-radius: 5px;
	}
`;

function loginReducer(state, action) {
	switch (action.type) {
		case 'field': {
			return {
				...state,
				[action.fieldName]: action.payload,
			};
		}
		case 'success': {
			return {
				...state,
				error: '',
			};
		}
		case 'changePasswordSuccess': {
			return {
				...state,
				error: '',
				username: '',
				password: '',
				recoverToken: '',
			};
		}
		case 'error': {
			return {
				...state,
				error: action.error,
				password: '',
			};
		}
		default:
			return state;
	}
}

const initialState = {
	username: '',
	password: '',
	recoverToken: '',
	error: '',
};

export default function FormRecoverPassword({ close }) {
	const [state, dispatch] = useReducer(loginReducer, initialState);
	const [showChangePasswordScreen, setShowChangePasswordScreen] = useState(false);
	const { username, password, error, recoverToken } = state;

	const getToken = async (e) => {
		e.preventDefault();

		Auth.forgotPassword(username)
			.then(() => {
				dispatch({ type: 'success' });
				setShowChangePasswordScreen(true);
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type: 'error', error: error.message });
				if (error.code === 'InvalidParameterException') {
					setShowChangePasswordScreen('confirmAgain');
				}
			});
	};

	const changePassword = async (e) => {
		e.preventDefault();

		Auth.forgotPasswordSubmit(username, recoverToken, password)
			.then(() => {
				dispatch({ type: 'changePasswordSuccess' });
				close();
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type: 'error', error: error.message });
			});
	};

	const resentConfirmCode = async (e) => {
		e.preventDefault();

		Auth.resendSignUp(username)
			.then(() => {
				dispatch({ type: 'success' });
				setShowChangePasswordScreen(null);
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type: 'error', error: error.message });
			});
	};

	let RecoverPasswordScreen = null;
	switch (showChangePasswordScreen) {
		case true:
			RecoverPasswordScreen = (
				<form onSubmit={changePassword}>
					{error && (
						<div className="form__error">
							<span>{error}</span>
						</div>
					)}
					<Typography>
						Ihnen wurde ein Token per E-Mail zugeschickt.
						<br />
						Bitte geben Sie diesen hier ein!
					</Typography>
					<TextField
						value={recoverToken}
						variant="outlined"
						margin="normal"
						required
						fullWidth
						label="Verifizierungscode eingeben"
						onChange={(e) =>
							dispatch({
								type: 'field',
								fieldName: 'recoverToken',
								payload: e.currentTarget.value,
							})
						}
					/>

					<InputPassword
						customInputlabel="Neues Passwort*"
						passwordValue={password}
						dispatch={(e) =>
							dispatch({
								type: 'field',
								fieldName: 'password',
								payload: e.currentTarget.value,
							})
						}
					/>

					<PasswordStrengthMeter StringtoCheck={password} />

					<BtnPrimary type="submit" variant="contained">
						Neues Passwort vergeben
					</BtnPrimary>
				</form>
			);
			break;

		case 'confirmAgain':
			RecoverPasswordScreen = (
				<form onSubmit={resentConfirmCode}>
					{error && (
						<div className="form__error">
							<span>{error}</span>
						</div>
					)}
					<Typography>Verifizierungs Mail erneut schicken!</Typography>
					<TextField
						value={username}
						variant="outlined"
						margin="normal"
						required
						fullWidth
						label="Benutzername oder Email"
						onChange={(e) =>
							dispatch({
								type: 'field',
								fieldName: 'username',
								payload: e.currentTarget.value,
							})
						}
					/>
					<BtnPrimary type="submit" variant="contained">
						Senden
					</BtnPrimary>
				</form>
			);

			break;

		default:
			RecoverPasswordScreen = (
				<form onSubmit={getToken}>
					{error && (
						<div className="form__error">
							<span>{error}</span>
						</div>
					)}
					<TextField
						value={username}
						variant="outlined"
						margin="normal"
						required
						fullWidth
						label="Benutzername oder Email"
						onChange={(e) =>
							dispatch({
								type: 'field',
								fieldName: 'username',
								payload: e.currentTarget.value,
							})
						}
					/>
					<BtnPrimary type="submit" variant="contained">
						Senden
					</BtnPrimary>
				</form>
			);
			break;
	}

	return <Root>{RecoverPasswordScreen}</Root>;
}
